import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import ModalRoutes from '../../ModalRoutes';
import Navbar from '../../../Navbar';
import ReactTooltip from 'react-tooltip';

import axios from "axios";
import { LoadingIcon } from '../../../Common/Loading_Icon';

import { setList } from '../../../../Actions/stakeholderActions.js';
import { checkCredentials } from '../../../../Helpers/checkCredentials.js';

import OutstandingMedia from './OutstandingMedia';
import CompletedMedia from './CompletedMedia';
import DismissedMedia from './DismissedMedia';
import { MediaAddWhite } from '../../../Common/Buttons/Icons';
import { Trans } from 'react-i18next';

class MediaOverview extends Component {
    constructor(props) {
        super(props);

        this.setTab = this.setTab.bind(this);
        this.renderTab = this.renderTab.bind(this);
        this.toggleMedia = this.toggleMedia.bind(this);

        this.state = {
            current_tab: "Outstanding",
            outstanding_bookings_data: {},
            loading_main: true
        };
    }

    componentDidMount() {
        document.title = "Media - FleetXPress";
        var self = this;

        axios.post('ajax/medialist/outstanding')
        .then(function(response) {
            checkCredentials(response);
            self.props.dispatch(setList("SET_OUTSTANDING_MEDIA_LIST", response?.data.outstanding_bookings))
            self.setState({
                loading_main: false,
                outstanding_bookings_data: response?.data
            });
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }


    setTab(tab_name) {
        if (tab_name === "Outstanding") {
            this.setState({
                loading_main: true
            })
            
            var self = this;

            axios.post('ajax/medialist/outstanding')
            .then(function(response) {
                checkCredentials(response);
                self.props.dispatch(setList("SET_OUTSTANDING_MEDIA_LIST", response?.data.outstanding_bookings))
                self.setState({
                    loading_main: false,
                    outstanding_bookings_data: response?.data
                });
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";
    
                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });
    
                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }

        this.setState({
            current_tab: tab_name
        })
    }

    renderTab() {
        if (this.state.current_tab === "Outstanding") {
            return(
                <OutstandingMedia history={this.props.history} match={this.props.match} location={this.props.location} outstanding_bookings={this.state.outstanding_bookings_data} filters={this.state.filters} loading_main={this.state.loading_main} />
            )
        } else if (this.state.current_tab === "Completed") {
            return(
                <CompletedMedia history={this.props.history} match={this.props.match} location={this.props.location} outstanding_bookings={this.state.outstanding_bookings_data.outstanding_bookings}/>
            )
        } else if (this.state.current_tab === "Dismissed") {
            return(
                <DismissedMedia history={this.props.history} match={this.props.match} location={this.props.location}/>
            )
        }
    }

    toggleMedia() {
        if (this.props.stakeholder.outstanding_media_list.length > 0) {
            this.props.history.push(this.props.match.url + "/create/media")
        }
    }

    render() {
        return (
            <div>
                <div className = "bkg-white-dark listviewnew medialist">
                    <Navbar history={this.props.history} match={this.props.match} location={this.props.location} />
                    <div className = "titlebar">
                        <div className = "titlebar-left">
                            <div className = "left">
                                <h1>Media</h1>
                                <div className = "btn-tabs ml-16">
                                    <a className = {"button tab px-32 tab-left" + (this.state.current_tab === "Outstanding" ? " is-active" : "")} onClick={() => this.setTab("Outstanding")}><Trans>Outstanding</Trans></a>
                                    <a className = {"button tab px-32 tab-middle" + (this.state.current_tab === "Completed" ? " is-active" : "")} onClick={() => this.setTab("Completed")}><Trans>Completed</Trans></a>
                                    <a className = {"button tab px-32 tab-right" + (this.state.current_tab === "Dismissed" ? " is-active" : "")} onClick={() => this.setTab("Dismissed")}><Trans>Dismissed</Trans></a>
                                </div>
                            </div>
                        </div>
                        <div className = "titlebar-right">
                            <div className = "right">
                                <div className = "desktop-action">
                                    <a className = {"button primary px-32" + (this.props.stakeholder.outstanding_media_list.length > 0 ? "" : " disabled")} onClick={this.toggleMedia}><span className = "mr-8" style={{verticalAlign: "text-top"}}>{MediaAddWhite()}</span><Trans>Add Media</Trans></a>
                                </div>
                                <div className = "mobile-action">
                                    <a className = {"button primary circle px-32" + (this.props.stakeholder.outstanding_media_list.length > 0 ? "" : " disabled")} onClick={this.toggleMedia}><span className = "mr-8" style={{verticalAlign: "text-top"}}>{MediaAddWhite()}</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.renderTab()}
                </div>
                <ModalRoutes match={this.props.match} history={this.props.history}/>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(MediaOverview)